import { api, handleResponse, handleError } from "./apiUtils";
import {
  GET_FREE_APPOINTMENTS,
  CREATE_APPOINTMENT,
  GET_BUSY_DAYS,
} from "../global/Constants/appointment";

export function createAppointment(appointment) {
  return api
    .post(CREATE_APPOINTMENT, appointment)
    .then((data) => {
      return data;
    })
    .catch(handleError);
}

export function getFreeAppointments(data) {
  const formattedDate = formatDate(data.date);
  const dateParam = encodeURIComponent(formattedDate);
  const doctorIdParam = encodeURIComponent(data.doctorId);
  const phoneParam = encodeURIComponent(data.phone);
  const checkCurrentDateParam = encodeURIComponent(data.checkCurrentDate);

  return api
    .get(
      `${GET_FREE_APPOINTMENTS}?date=${dateParam}&doctorId=${doctorIdParam}&phone=${phoneParam}&checkCurrentDate=${checkCurrentDateParam}`
    )
    .then(handleResponse)
    .catch(handleError);
}

function formatDate(date) {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function getBusyDays(data) {
  return api
    .get(
      `${GET_BUSY_DAYS}?month=${data.month}&year=${data.year}&doctorId=${data.doctorId}`
    )
    .then(handleResponse)
    .catch(handleError);
}